import { ListState } from 'react-stately'

import { SelectItem } from '../select/select'
import { createContextAndHook } from '../utils/create-context'

export const [MultiselectStateContext, useMultiselectListContext] =
  createContextAndHook<ListState<SelectItem>>()
